export default __webpack_public_path__ + "static/sushi_etoile-e454a3a0bff5ac24aacba6a08b65150b.png";